import { render, staticRenderFns } from "./CadastroItemTabela.vue?vue&type=template&id=66176fbc&"
import script from "./CadastroItemTabela.vue?vue&type=script&lang=js&"
export * from "./CadastroItemTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports